<template>
  <div class="layout-container">
    <!-- PC端头部 -->
    <Header v-if="!isMobile" class="header" />
    
    <!-- 移动端头部 -->
    <MobileHeader v-if="isMobile" :page-title="getPageTitle()" />
    
    <main class="main-content" :class="{ 'mobile-main': isMobile }">
      <slot />
    </main>

    <!-- Footer 外层 wrapper -->
    <div class="footer-wrapper" :style="{
      backgroundColor: footerArcColor,
    }">
      <!-- PC端Footer -->
      <Footer v-if="!isMobile" class="footer" />
      
      <!-- 移动端Footer -->
      <MobileFooter v-if="isMobile" />
    </div>
  </div>
</template>


<script setup lang="ts">
import Header from "../components/Header.vue";
import MobileHeader from "../components/MobileHeader.vue";
import Footer from "../components/Footer.vue";
import MobileFooter from "../components/MobileFooter.vue";
import { useRoute } from "vue-router";
import { ref, watchEffect, computed } from "vue";
import { useDeviceDetection } from "@/utils/deviceDetection";

const { isMobile } = useDeviceDetection();
const route = useRoute();

const footerArcColor = ref<string>((route.meta.footerArcColor as string) || "#ffffff");
const footerOverlap = ref(false);

// 获取页面标题
const getPageTitle = () => {
  const titleMap = {
    '/': 'Home',
    '/about': 'About Us',
    '/core-offers': 'Our Offers',
    '/contact-us': 'Contact Us',
    '/core-offers/source-product': 'Source Product'
  };
  return titleMap[route.path] || 'Creston Group';
};

watchEffect(() => {
  const lastMatched = route.matched.at(-1);
  const color = lastMatched?.meta?.footerArcColor;
  footerArcColor.value = typeof color === "string" ? color : "#ffffff";
  footerOverlap.value = !!lastMatched?.meta?.footerOverlap;
});
</script>

<style scoped>
.layout-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f3f8ff;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: transparent;
}

.main-content {
  flex: 1;
  margin-top: 0;
  padding-top: 0;
  width: 100%;
  background-color: rgb(245, 248, 255);
  box-sizing: border-box;
}

.footer {
  height: 46vh;
  background-color: #0d0971;
  color: rgb(255, 255, 255);
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
}
.mobile-main {
  margin-top: 80px; /* 为移动端头部留出空间 */
}/* footer 你自己处理，暂不影响布局 */
</style>
